// extracted by mini-css-extract-plugin
export default {"AddPage":"AddPage_AddPage__5SLMr","mainContent":"AddPage_mainContent__r5tEH","footerWrapper":"AddPage_footerWrapper__EizAd"};